import React from "react";

interface LabHeaderProps {
  title: string;
  className?: string;
  centered?: boolean;
}

export default function LabHeader({
  title,
  className = "",
  centered = false,
}: LabHeaderProps) {
  return (
    <div className={`flex items-center ${className}`}>
      <h2 className="text-2xl font-bold text-gray-900">Lab: {title}</h2>
    </div>
  );
}
